import React from 'react';
import { FacebookShareButton, FacebookIcon, WhatsappIcon, WhatsappShareButton, PinterestShareButton, PinterestIcon, TwitterIcon, TwitterShareButton, LinkedinIcon, LinkedinShareButton } from 'react-share';
import { APP_BASE_URL_SHARE } from '../constants/config';
const SocialShare = (props) => {

    const { fb, whatsapp, linkedin, pinterest, tw, shareUrl } = props;
    const ICON_SIZE = 36;
    //console.log( fb );
    return (
        <> 
            <span className="ico"><i class="fa fa-share-alt" aria-hidden="true"></i></span>
            <span>SHARE WITH:</span>
            { fb && fb.url && <FacebookShareButton 
                    url={`${APP_BASE_URL_SHARE}${fb.url}`}
                    quote={fb.quote}
                    hashtag={fb.hasTag}
                    className='_fbCustom'>
                    <FacebookIcon size={ICON_SIZE} />
                </FacebookShareButton>
            }
            
             { whatsapp && whatsapp.url && <WhatsappShareButton
                    title={whatsapp.title}
                    url={`${APP_BASE_URL_SHARE}${whatsapp.url}`}
                    separator=""
                >
                    <WhatsappIcon size={ICON_SIZE}/>
                </WhatsappShareButton>
            }
            
            { linkedin && linkedin.url && <LinkedinShareButton
                    title={linkedin.title}
                    summary={linkedin.title}
                    source="Carryon bike"
                    url={`${APP_BASE_URL_SHARE}`}
                >
                    <LinkedinIcon size={ICON_SIZE}/>
                </LinkedinShareButton>
            }
        
            { pinterest && pinterest.url && <PinterestShareButton
                    url={`${APP_BASE_URL_SHARE}${pinterest.url}`}
                    title={pinterest.title}
                    media={`${APP_BASE_URL_SHARE}${pinterest.url}`}
                >
                    <PinterestIcon size={ICON_SIZE}/>
                </PinterestShareButton>
            }
        
            { tw && tw.url && <TwitterShareButton
                    title={tw.title}
                    via="Carryon.bike"
                    url={`${APP_BASE_URL_SHARE}${tw.url}`}
                >
                    <TwitterIcon size={ICON_SIZE}/>
                </TwitterShareButton>

            } 
        </>
    )
}

export default SocialShare;
